import { render, staticRenderFns } from "./ElectronicaView.vue?vue&type=template&id=2fd9d04a"
import script from "./ElectronicaView.vue?vue&type=script&lang=js"
export * from "./ElectronicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports